<template>
  <article :id="documentId">
    <h3 class="color_title">{{title}} 全{{colorList.length}}色</h3>
    <template>
      <div class="colorPallet">
        <div>
          <div>
            <img :src="color.imgB" />
            <div class="enlargement" @click="previewColor(color.imgB)">
              <img :src="getImage('common/icon_enlargement.svg')">
            </div>
          </div>
          <div class="color_name" v-if="colorList.length > 0">
            <div v-if="isSelectedColor">{{color.name}}</div>
            <div v-else>カラーが選択されていません。</div>
          </div>
        </div>
        <div class="color_list">
          <!-- <div class="left_arrow" @click="prevPage()">
            <div v-bind:class="{btn_left:true, noDisp: isColorPrev}"></div>
          </div> -->
          <figure v-for="(color,index) in colorList" :key="documentId + '-' + index" :value="color.id">
            <img :src="color.img" v-bind:class="{selected: hasSelectId(color.id)}" @click="$emit('selectColor', color)">
          </figure>
          <!-- <div class="right_arrow" @click="nextPage()">
            <div v-bind:class="{btn_right:true, noDisp: isColorNext}"></div>
          </div> -->
        </div>
        <div class="color_list_sp">
          <select v-model="selColor" @change="$emit('selectColor', selColor)">
            <option v-for="(color,index) in colorList" :key="documentId + '-' + index" :value="color">{{color.name}}</option>
          </select>
        </div>
      </div>
    </template>
  </article>
</template>
<script>
import * as App from '../../../../../utils/App'
import * as AppEc from '../../../../utils/AppEc'

const MAX_COLOR_VIEW_CNT = 10

export default {
  name: 'dcColor',
  components: {
  },
  props: {
    title: String,
    documentId: String,
    colorList: Array,
    color: Object
  },
  data () {
    return {
      page: 1,
      selColor: {}
    }
  },
  methods: {
    prevPage: function () {
      if (this.page > 1) {
        this.page--
      }
    },
    nextPage: function () {
      if (this.page < this.maxPage) {
        this.page++
      }
    },
    // setBackgroundColor: function (nextColor) {
    //   document.getElementById(this.documentId).style.backgroundImage = 'url("' + nextColor.imgB + '")'
    // },
    hasSelectId: function (targetId) {
      if (!this.color) return false
      if (!Object.keys(this.color).length > 0) return false
      if (targetId !== this.color.id) return false
      return true
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    previewColor: function (img) {
      let modalData = {
        image: img
      }
      AppEc.showImageViewerModal(modalData)
    }
  },
  computed: {
    isColorPrev: function () {
      if (this.page <= 1) return true
      return false
    },
    isColorNext: function () {
      if (Number(this.page) === Number(this.maxPage)) return true
      return false
    },
    // viewColorList: function () {
    //   if (!this.colorList) return
    //   let startIdx = (this.page - 1) * MAX_COLOR_VIEW_CNT
    //   let endIdx = ((this.page) * MAX_COLOR_VIEW_CNT)
    //   return this.colorList.filter(function (element, index) {
    //     return (index >= startIdx && index < endIdx)
    //   })
    // },
    isSelectedColor: function () {
      if (!this.color) return
      if (!Object.keys(this.color).length > 0) return false
      return true
    },
    maxPage: function () {
      return Math.ceil(this.colorList.length / MAX_COLOR_VIEW_CNT)
    }
  },
  watch: {
    // color: function () {
    //   if (this.color) {
    //     this.setBackgroundColor(this.color)
    //   }
    // },
    colorList: function () {
      this.page = 1
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<style src="../../../../css/dc-customize.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/input/color/DcColorPallet.vue